import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=749ac74b&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=ts&"
export * from "./feedback.vue?vue&type=script&lang=ts&"
import style0 from "./feedback.vue?vue&type=style&index=0&id=749ac74b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749ac74b",
  null
  
)

export default component.exports